import React, { useState, useEffect } from "react";

import { CheckIcon, ErrorIcon, LoadingIcon } from "../Icons";
import { H3, Icon } from "@blueprintjs/core";
import "./RunStatusHeader.scss";

type Props = {
    connected: boolean | undefined;
    connectionError: boolean;
    automate: boolean | undefined;
    automateError: boolean;
    inProgress: boolean | undefined;
};

export default function RunStatusHeader({ connected, connectionError, automate, automateError, inProgress }: Props) {
    const [connectState, setConnectState] = useState<string>("initState");
    const [compileIcon, setConnectIcon] = useState<any>(null);

    const [automateState, setAutomateState] = useState<string>("initState");
    const [automateIcon, setAutomateIcon] = useState<any>(null);

    const [doneState, setDoneState] = useState<string>("initState");
    const [subscribeIcon, setSubscribeIcon] = useState<any>(null);

    useEffect(() => {
        if (connected !== undefined) {
            console.log("Header connected", connected);
            if (!connected) {
                setConnectState("inProgressState");
                setConnectIcon(<LoadingIcon />);
            } else {
                setConnectState("doneState");
                setConnectIcon(<CheckIcon />);
            }
        } else {
            setConnectState("initState");
            setConnectIcon(null);
        }

        if (connectionError) {
            setConnectState("errorState");
            setConnectIcon(<ErrorIcon />);
        }

        if (automate !== undefined) {
            if (automate) {
                setAutomateState("inProgressState");
                setAutomateIcon(<LoadingIcon />);
            } else {
                setAutomateState("doneState");
                setAutomateIcon(<CheckIcon />);
            }
        } else {
            setAutomateState("initState");
            setAutomateIcon(null);
        }

        if (automateError) {
            setAutomateState("errorState");
            setAutomateIcon(<ErrorIcon />);
        }

        if (inProgress !== undefined) {
            if (inProgress) {
                setDoneState("inProgressState");
                setSubscribeIcon(<LoadingIcon />);
            } else {
                if (automateError || connectionError) {
                    setDoneState("errorState");
                    setSubscribeIcon(<ErrorIcon />);
                } else {
                    setDoneState("doneState");
                    setSubscribeIcon(<CheckIcon />);
                }
            }
        } else {
            setDoneState("initState");
            setSubscribeIcon(null);
        }
    }, [connected, connectionError, automate, automateError, inProgress]);

    return (
        <div className="status-header">
            <div className="status">
                <H3 className={connectState}>Connect {compileIcon}</H3>
                <div id="chevron">
                    <Icon size={30} color="#BFCCD6" icon="chevron-right" />
                </div>
            </div>
            <div>
                <div className="status">
                    <H3 className={automateState}> Running {automateIcon}</H3>
                    <div id="chevron">
                        <Icon size={30} color="#BFCCD6" icon="chevron-right" />
                    </div>
                </div>
            </div>

            <div>
                <div className="status">
                    <H3 className={doneState}> Done {subscribeIcon} </H3>
                </div>
            </div>
        </div>
    );
}
